import { ProductDetails } from "components";
import React from "react";

const ProductDetailsPage = () => {
  return (
    <div>
      <ProductDetails />
    </div>
  );
};

export { ProductDetailsPage };
